import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import CoursesListItem from 'app/main/modules/courses/CoursesListItem';
import LeaveListItem from 'app/main/modules/leave/LeaveListItem';
import RequestsListItem from 'app/main/modules/requests/RequestsListItem';

import UsersDetailsTab from './tabs/UsersDetailsTab';
import UsersContactTab from './tabs/UsersContactTab';
import UsersReadReceiptsTab from './tabs/UsersReadReceiptsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <UsersDetailsTab {...props} />
	},
	{
		id: 'contacts',
		title: 'TAB_CONTACTS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model }) => <UsersContactTab itemUid={model.user_uid} />
	},
	{
		id: 'read-notifications',
		title: 'TAB_READ_RECEIPTS',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('communications') || authorizer.cannot('view', 'communications'),
		content: ({ model, refresh, updateRefresh }) => (
			<UsersReadReceiptsTab userUid={model.user_uid} refresh={refresh} updateRefresh={updateRefresh} />
		)
	},
	{
		id: 'leave',
		title: 'MODULE_LEAVE_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('leave') || authorizer.cannot('view', 'leave'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="leave"
				content={{ type: 'list', itemLayout: LeaveListItem, id: 'leaveView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'leav_user_uid', filt_clause: 'equals', filt_value: model.user_uid }]}
			/>
		)
	},
	{
		id: 'requests',
		title: 'MODULE_REQUESTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('requests') || authorizer.cannot('view', 'requests'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="requests"
				content={{ type: 'list', itemLayout: RequestsListItem, id: 'requestView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[
					{ filt_field: 'reqs_user_signaller_uid', filt_clause: 'equals', filt_value: model.user_uid }
				]}
			/>
		)
	},
	{
		id: 'courses',
		title: 'TAB_ATTENDED_COURSES',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('courses') || authorizer.cannot('view', 'courses'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="courses_users"
				content={{ type: 'list', itemLayout: CoursesListItem, id: 'coursesView' }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'crus_user_uid', filt_clause: 'equals', filt_value: model.user_uid }]}
			/>
		)
	}
];

export default tabs;
